export default __webpack_public_path__ + "static/media/EnergyIndustries_icon.a3f58514.svg";